import { getAddressConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Address/Address.config';
import { getConfigFields as getCounselingConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Counseling/Counseling.config';
import { getConfigFields as getDemographicConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Demographic/Demographic.config';
import { getConfigFields as getFinancesConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Finances/Finances.config';
import { getConfigFields as getHomeownershipConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/HomeownershipEducationAndHousingCounseling/HomeownershipEducationAndHousingCounseling.config';
import { getConfigFields as getLanguagePreferenceConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/LanguagePreference/LanguagePreference.config';
import { getConfigFields as getMilitaryServicesConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/MilitaryServices/MilitaryServices.config';
import { getConfigFields as getPropertyAndLoanConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/PropertyAndLoan/PropertyAndLoan.config';
import { getPersonalInfoConfigFields } from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/PersonalInfo/PersonalInfo.config';
import { getConfigFields as getAssetConfigFields } from 'app/pages/loanApplication/tabs/financialInfo/UpdateTableModal/Content/SectionContent/Assets/Assets.config';
import { getConfigFields as getIncomeConfigFields } from 'app/pages/loanApplication/tabs/financialInfo/UpdateTableModal/Content/SectionContent/EmploymentAndIncome/EmploymentAndIncome.config';
import { getConfigFields as getLiabilitiesConfigFields } from 'app/pages/loanApplication/tabs/financialInfo/UpdateTableModal/Content/SectionContent/Liabilities/Liabilities.config';
import { getConfigFields as getReoConfigFields } from 'app/pages/loanApplication/tabs/financialInfo/UpdateTableModal/Content/SectionContent/Reo/Reo.config';

import {
  asianRaceOptions,
  ethnicityOptions,
  hispanicOrLatinoEthnicityOptions,
  nativeHawaiianOrOtherRaceOptions,
} from 'constants/options';

const emptyEntityParams = { entityId: '' };
const emptyRecordParams = { recordId: '' };

export const raceAndEthnicityHistoryConfigFields = [
  ...asianRaceOptions,
  ...ethnicityOptions,
  ...hispanicOrLatinoEthnicityOptions,
  ...nativeHawaiianOrOtherRaceOptions,
].reduce((acc, { name, value }) => {
  acc[value] = {
    nameInModel: value,
    inputProps: { label: name },
  };

  return acc;
}, {});

export const linkedToEntityBorrowerIdFieldConfig = {
  borrowerId: {
    nameInModel: 'borrowerId',
    inputProps: { label: 'Borrower' },
  },
};

export const personalInfoConfigFields = getPersonalInfoConfigFields(emptyEntityParams);
export const addressConfigFields = getAddressConfigFields({
  entityId: '',
  isPreviousResidence: true,
});
export const reoConfigFields = getReoConfigFields(emptyRecordParams);
export const assetConfigFields = getAssetConfigFields(emptyRecordParams);
export const liabilitiesConfigFields = getLiabilitiesConfigFields(emptyRecordParams);
export const incomeConfigFields = getIncomeConfigFields(emptyRecordParams);
export const declarationConfigFields = {
  ...getFinancesConfigFields(emptyEntityParams),
  ...getDemographicConfigFields(emptyEntityParams),
  ...getMilitaryServicesConfigFields(emptyEntityParams),
  ...getPropertyAndLoanConfigFields(emptyEntityParams),
  ...getHomeownershipConfigFields(emptyEntityParams),
  ...getLanguagePreferenceConfigFields(emptyEntityParams),
  ...getCounselingConfigFields(emptyEntityParams),
};
